import { useEffect } from 'react'
import { Form, Input, Button, Row, Col } from 'antd'
import { SKU, CreateSKUForm } from '../../types'

interface SKUFormProps {
  initialValues?: SKU
  onSubmit: (values: CreateSKUForm) => Promise<void>
  onCancel: () => void
  loading?: boolean
}

const SKUForm: React.FC<SKUFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  loading = false
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        barcode: initialValues.barcode,
        styleNumber: initialValues.styleNumber,
        styleName: initialValues.styleName,
        styleShort: initialValues.styleShort,
        colorCode: initialValues.colorCode,
        colorDescription: initialValues.colorDescription,
        colorChinese: initialValues.colorChinese,
        size: initialValues.size,
        source: initialValues.source,
      })
    }
  }, [initialValues, form])

  const handleSubmit = async (values: CreateSKUForm) => {
    try {
      await onSubmit(values)
      form.resetFields()
    } catch (error) {
      // 错误处理已在service层处理
    }
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      autoComplete="off"
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="条形码"
            name="barcode"
            rules={[
              { required: true, message: '请输入条形码' },
              { max: 50, message: '条形码长度不能超过50个字符' }
            ]}
          >
            <Input placeholder="请输入条形码" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="款号"
            name="styleNumber"
            rules={[
              { required: true, message: '请输入款号' },
              { max: 50, message: '款号长度不能超过50个字符' }
            ]}
          >
            <Input placeholder="请输入款号" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="款名"
            name="styleName"
            rules={[
              { required: true, message: '请输入款名' },
              { max: 200, message: '款名长度不能超过200个字符' }
            ]}
          >
            <Input placeholder="请输入款名" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="款名简称"
            name="styleShort"
            rules={[
              { max: 20, message: '款名简称长度不能超过20个字符' }
            ]}
          >
            <Input placeholder="请输入款名简称" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="颜色代码"
            name="colorCode"
            rules={[
              { required: true, message: '请输入颜色代码' },
              { max: 20, message: '颜色代码长度不能超过20个字符' }
            ]}
          >
            <Input placeholder="请输入颜色代码" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="颜色描述"
            name="colorDescription"
            rules={[
              { max: 100, message: '颜色描述长度不能超过100个字符' }
            ]}
          >
            <Input placeholder="请输入颜色描述" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="颜色中文"
            name="colorChinese"
            rules={[
              { max: 100, message: '颜色中文长度不能超过100个字符' }
            ]}
          >
            <Input placeholder="请输入颜色中文" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="尺码"
            name="size"
            rules={[
              { required: true, message: '请输入尺码' },
              { max: 20, message: '尺码长度不能超过20个字符' }
            ]}
          >
            <Input placeholder="请输入尺码" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="来源"
            name="source"
            rules={[
              { max: 20, message: '来源长度不能超过20个字符' }
            ]}
          >
            <Input placeholder="请输入来源" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Row gutter={8}>
          <Col>
            <Button type="primary" htmlType="submit" loading={loading}>
              {initialValues ? '更新' : '创建'}
            </Button>
          </Col>
          <Col>
            <Button onClick={onCancel}>
              取消
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  )
}

export default SKUForm